export default "__VITE_ASSET__BfxUJIrJ__"